import gql from 'graphql-tag';

export default gql`
  mutation newClickToCall($eventId: ID!, $voiceCallInput: VoiceCallInput!) {
    newClickToCall(eventId: $eventId, voiceCallInput: $voiceCallInput)
  }
`;
